/* @flow */

export const NS = "http://www.w3.org/2000/svg";

// color scheme for granule selection
export const THEME = {
    selected: {
        color: 'rgb(63,81,181)',
        opacity: 0.7,
        edge: 2
    },
    plain: {
        color: 'white',
        opacity: 0.2,
        edge: 2
    },
    metric: {
        color: 'none',
        opacity: 0.7,
        edge: 0 // removes ugly white border around color-coded granules
    }
}

export { ranks, categories, categoricalGradient, Key } from '../common/constants'

const minWidth = Math.min(800, window.innerWidth);

const controls = document.getElementById("controls")
const header = document.getElementById('header')
const headerHeight = header ? header.offsetHeight : 0

const footer = document.getElementById('map-footer')
const footerHeight = footer ? footer.offsetHeight : 0

export const mapDimensions = { width: 0, height: 0 }
const updateDimensions = () => {
    let controlsWidth = controls ? controls.offsetWidth : 0
    mapDimensions.width = Math.max(window.innerWidth - controlsWidth, minWidth)
    mapDimensions.height = window.innerHeight - headerHeight - footerHeight
}
updateDimensions()
addEventListener("resize", updateDimensions)

export * from '../common/types';
